import TextInputColumnFilter from "../../../shared/table/TextInputColumnFilter";
export const TABLE_COLUMNS = [
// { Header: "Active", accessor: "active" },
    { Header: "BU", accessor: "bu" ,Filter: TextInputColumnFilter,},
    { Header: "Column 1", accessor: "col1", Filter: TextInputColumnFilter, },
    { Header: "Column 3", accessor: "col3", Filter: TextInputColumnFilter, },
    { Header: "Column 5", accessor: "col5", Filter: TextInputColumnFilter, },
    { Header: "LTM", accessor: "ltm", Filter: TextInputColumnFilter, },
    // { Header: "Look Up", accessor: "lookup" },
    { Header: "Run Charge Type", accessor: "runChargeType", Filter: TextInputColumnFilter, },
    {
        Header: "Actions",
        id: "Actions",
    }
];
  